var filelist = {

    //预览功能 如果不传articleId 则弹窗的标题不会添加链接
    preview: function (url, title, needLogin, articleId, fileIds, fileName, articleUrl, isJump, hiddenDown, wh, previewUrl, leftPageNum, continueFn, verifyType, verifyCookie) {
        //阻止冒泡
        try {
            var e = window.event || arguments.callee.caller.arguments[0] ;
            e.stopPropagation();
        }catch (e) {

        }
        var isNeedLogin = parseInt(needLogin) || false;


        //判断是否需要登录预览不需要
        /*if (isNeedLogin) {
            if (!isLogin()) {
                //用户行为
                userRecode({behaviorType: '预览资料', behaviorResult: '无',});
                //跳转登录
                window.location.href = window.cateData.url.loginAndBack + turnPara;
                return;
            }
        }*/

        //用户行为
        userAction.preview(fileName || title);

        //进行登录判断

        //打开预览窗口
        if(!hiddenDown){
            hiddenDown = fileIds?'0':'1';
        }
        var fileUrl = httpsTohttp(url);
        var previewUrl = httpsTohttp(previewUrl);
        msg.filePreviewDialog(fileUrl, title, needLogin, articleId, fileIds, fileName, articleUrl, isJump, hiddenDown, wh, previewUrl, leftPageNum, continueFn, verifyType, verifyCookie);
        function httpsTohttp(url) {
            if(!url){
                return false;
            }
            if(url.indexOf('https') > -1){
                url = url.replace("https","http");
            }
            return '//ow365.cn/?i=16574&furl=' + url;
        }
    },

    // 预览PDF： 除IE浏览器使用弹窗，其他浏览器新开页面直接打开PDF
    previewWithNewPage: function (url, title){
        if (window.client.browseInfo.browser === 'IE'){
            url = url + '&type=download&isPreview=1';
            this.preview(url,title);
        }else {
            window.open(url);
        }
    },

    //下载功能
    // silenceDownload 静默下载，为true 时，不会弹窗，使用 otherEmail 直接发送
    download: function (fileIds, articleId, title, needLogin, fileName, otherEmail, silenceDownload, callBack) {
        //阻止冒泡
        try {
            var e = window.event || arguments.callee.caller.arguments[0] ;
            e.stopPropagation();
        }catch (e) {

        }
        var isNeedLogin = parseInt(needLogin) || false;

        var fid = fileIds || '';

        //跳转参数
        // var turnPara = encodeURIComponent('?dialogType=download&fileIds=' + fileIds + '&articleId=' + articleId + '&title=' + title + '&needLogin=' + needLogin);

        gio('track', 'Filedownload_click', {'consultEntrancePage': document.title , 'consultEntrancePageURL': document.URL, 'FilesTitle_Fifth':title, 'FilesID_Fifth':fid});  //埋点实施方案

        //判断是否需要登录
        if (true || isNeedLogin) {
            if (!isLogin()) {
                //用户行为
                userAction.download('无');

                //将参数存入本地存贮
                try {
                    localStorage.setItem('dialogType', 'download');
                    localStorage.setItem('fileIds', fileIds);
                    localStorage.setItem('articleId', articleId);
                    localStorage.setItem('title', title);
                    localStorage.setItem('needLogin', needLogin);
                    localStorage.setItem('fileName', fileName);
                }catch (e) {
                    console.log('localStorage 已满请清理', e);
                }

                //跳转登录
                // common.gotoLogin();
                msg.dialogDtf({
                    title:'提示', //弹窗标题
                    desc:'您需要登录后才可下载文件', //弹窗文本内容，支持html
                    showCloseBtn:true, //是否显示关闭按钮
                    linkText:'立即登录', // 链接文本
                    linkUrl:window.cateData.url.loginAndBack, // 跳转链接地址
                })
                return;
            }
        }

        var email = otherEmail || getUserInfo.options.email;
        if (!email) {
            email = '';
        }


        //参数
        var option = {
            articleId: articleId,
            fileList: [fid],
            email: email,
            forEmailTemp: false,
            emailSubject: window.cateData.email.emailSubject,
            senderEmail: window.cateData.email.senderEmail,
            senderName: window.cateData.email.senderName,
            sess: window.cateData.userInfo.sess,
            openId: getUserInfo.options.openId,
            referenceUrl: window.location.href,
            instanceId: 0,
            moduleType: 0,
            extra: {
                tenantId: window.cateData.tenantId,
                instanceId: 0,
                memberId: window.cateData.userInfo.memberId,
                moduleId: 0,
                openId: getUserInfo.options.openId,
                weChatId: window.cateData.weChatId,
                objInstanceId: 0,
                source: window.cateData.device,
            },
            globalUserId: getUserInfo.options.globalUserId,
            browseInfo: client.browseInfo,
        };

        if(silenceDownload){
            sendFile(email);
        }else{
            msg.dialogSedfile('', email, sendFile);
        }

        function sendFile(sendEmail) {
            option.email = sendEmail;
            gioTrackAction.downloadConfirm(title,fid,sendEmail); // 点击确认埋码
            postJson(window.cateData.api.downloadWithEmail, option, function (data) {
                if (data.errCode !== 0) {
                    msg.toast(data.msg);
                    //用户行为
                    userAction.download('下载失败');
                } else {
                    //用户行为
                    userAction.download(fileName);
                    if(typeof callBack === 'function'){
                        callBack()
                    }else{
                        msg.toastSedfile();
                    }
                }
            });
        }

    },

    //视频播放
    video: function (url, title, needLogin, articleId, articleUrl,autoCloseTime, needRecord) {


        //阻止冒泡
        try {
            var e = window.event || arguments.callee.caller.arguments[0] ;
            e.stopPropagation();
        }catch (e) {

        }
        var isNeedLogin = parseInt(needLogin) || false;

        //跳转参数
        // var turnPara = encodeURIComponent('?dialogType=video&url=' + url + '&title=' + title + '&needLogin=' + needLogin + '&articleId=' + articleId);


        //判断是否需要登录
        if (isNeedLogin) {
            if (!isLogin()) {
                //跳转登录
                //用户行为
                userRecode({behaviorType: '观看视频', behaviorResult: '无',});

                //将参数存入本地存贮
                try {
                    localStorage.setItem('dialogType', 'video');
                    localStorage.setItem('url', url);
                    localStorage.setItem('articleId', articleId);
                    localStorage.setItem('articleUrl', articleUrl);
                    localStorage.setItem('title', title);
                    localStorage.setItem('needLogin', needLogin);
                }catch (e) {
                    console.log('localStorage 已满请清理', e);
                }
                common.gotoLogin();
                return;
            }
        }

        //用户行为
        userRecode({behaviorType: '观看视频', behaviorResult: title,});

        msg.videoDialog(url, title, articleId, articleUrl,autoCloseTime, needRecord);
    },

    //从参数启动视频弹窗
    initVideo: function () {
        /*var url = getUrlPara('url')
        var title = getUrlPara('title')
        var needLogin = getUrlPara('needLogin')
        var articleId = getUrlPara('articleId')*/

        var url = localStorage.getItem('url');
        var title = localStorage.getItem('title');
        var needLogin = localStorage.getItem('needLogin');
        var articleId = localStorage.getItem('articleId');
        var articleUrl = localStorage.getItem('articleUrl');

        this.video(url, title, needLogin, articleId, articleUrl);
        this.clearStorage('dialogType', 'url', 'articleId', 'title', 'needLogin' ,'articleUrl');
    },

    //从参数启动下载弹窗
    initDown: function () {
        var fileIds = localStorage.getItem('fileIds');
        var title = localStorage.getItem('title');
        var needLogin = localStorage.getItem('needLogin');
        var articleId = localStorage.getItem('articleId');
        var fileName = localStorage.getItem('fileName');
        this.download(fileIds, articleId, title, needLogin, fileName);
        this.clearStorage('dialogType', 'fileIds', 'articleId', 'title', 'needLogin','fileName');
    },

    //本地存储数据
    clearStorage: function () {
        var paArr = arguments;
        for(var i=0; i<paArr.length; i++){
            // delUrlPara(paArr[i]);
            localStorage.removeItem(paArr[i]);
        }
    },

    //初始化
    init: function (s) {

        if(s){
            //判断是否为登录跳回页面，获取地址栏参数，自动打开下载弹窗
            var dialogType = localStorage.getItem('dialogType');
            if (dialogType) {
                switch (dialogType) {
                    case 'video':
                        this.initVideo();
                        break;
                    case 'download':
                        this.initDown();
                        break;
                    default:
                        break;
                }
            }
        }else{
            this.clearStorage('dialogType', 'fileIds', 'articleId', 'title', 'needLogin','fileName', 'url', 'articleUrl');
        }

    }

};
